import React from 'react';
import ModalPane from './ModalPane';
import { Loader } from '../Buttons/IconButton/Icons';

export default function LoaderModal() {
  return (
    <div className="loader-modal">
      <ModalPane>
        <>
          <Loader className="button-loader" isModal={true} />
          <div className="modal-body body-text-2">Setting up speech…</div>
        </>
      </ModalPane>
    </div>
  );
}
